var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import otcDi from "../../../../mainDi/features/OTC/servicelocator";
import { EBuySellFlag } from "@domains/features/Markets/OTC/entities/CashFlow";
import { EBuySell } from "@frameworks/NCD/Enum/OTC";
import actions from "@redux/feature/Markets/NCD/actions/TransactionJourneyActions";
var useValidateDirtyPrice = function () {
    var _a = __read(useState(false), 2), loader = _a[0], setLoader = _a[1];
    var _b = __read(useState({ error: null, isOpen: false }), 2), errorData = _b[0], setErrorData = _b[1];
    var cActions = new actions();
    var _c = useSelector(function (state) { return state.markets.Otc.transactionJourneyReducer; }), transactionDetails = _c.transactionDetails, draftOrderDetails = _c.draftOrderDetails;
    var watchListRequestPayload = useSelector(function (state) { return state.markets.Otc.productBouquetReducer; }).watchListRequestPayload;
    var isDraft = draftOrderDetails && Object.keys(draftOrderDetails).length > 0;
    var fetchDirtyPrice = function (dirtyPrice) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, 3, 4]);
                    setLoader(true);
                    return [4 /*yield*/, otcDi.transactionJourney.validateDirtyPrice({
                            isin_id: Number(transactionDetails === null || transactionDetails === void 0 ? void 0 : transactionDetails.isin_id),
                            dirtyprice: Number(dirtyPrice),
                            buy_sell_flag: transactionDetails.buySellFlag === EBuySell.Buy
                                ? EBuySellFlag.BUY
                                : EBuySellFlag.SELL,
                        })];
                case 1:
                    _b.sent();
                    setErrorData({
                        error: null,
                        isOpen: false,
                    });
                    cActions.validateDirtyPrice({
                        requestid: "",
                        success: false,
                        message: "",
                        statuscode: "",
                        errors: "",
                        data: null,
                    });
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _b.sent();
                    setErrorData({
                        error: error_1,
                        isOpen: true,
                    });
                    cActions.validateDirtyPrice({
                        requestid: "",
                        success: false,
                        message: "",
                        statuscode: "",
                        errors: "",
                        data: (_a = error_1 === null || error_1 === void 0 ? void 0 : error_1.errorParams) === null || _a === void 0 ? void 0 : _a.data,
                    });
                    return [3 /*break*/, 4];
                case 3:
                    setLoader(false);
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        var _a, _b;
        if (isDraft) {
            fetchDirtyPrice((watchListRequestPayload === null || watchListRequestPayload === void 0 ? void 0 : watchListRequestPayload.buysellflg) === EBuySellFlag.BUY
                ? String((_a = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _a === void 0 ? void 0 : _a.buy_price_min)
                : String((_b = draftOrderDetails === null || draftOrderDetails === void 0 ? void 0 : draftOrderDetails.data) === null || _b === void 0 ? void 0 : _b.min_sell_price));
        }
    }, []);
    return { loader: loader, errorData: errorData, fetchDirtyPrice: fetchDirtyPrice };
};
export default useValidateDirtyPrice;
